import type { paths } from "../../__definitions__/autopilot.changeengine.com-definitions";
import { WorkerApiService } from "../../server/api/worker";
import type { Workers } from "../../utils/service-url";

type EmailSubjectsRequest =
  paths["/email_subjects"]["post"]["requestBody"]["content"]["application/json"];

export type EmailSubjectsResponse =
  paths["/email_subjects"]["post"]["responses"]["200"]["content"]["application/json"];

export class MomentSubjectService extends WorkerApiService {
  module = "autopilot" as const satisfies Workers;

  async suggestSubjects(request: EmailSubjectsRequest): Promise<EmailSubjectsResponse> {
    const response = await this.post<EmailSubjectsResponse>("email_subjects", request);

    if (response.error) {
      throw new Error(response.error);
    }

    if (!response.data) {
      throw new Error("Failed to suggest email subjects");
    }

    return response.data;
  }
}
